import { FilterDescriptor } from '@progress/kendo-data-query'
import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { SubscriptionDetailDetailsFilterKey } from 'api/Trading-Accounts/Types/SubscriptionDetailDetailsDto'
import { useAppSelector } from 'store'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { SelectFilter } from './SelectFilter'

const SubscriptionClassificationTypeFilter = ({
  filter,
  onFilterChange,
}: {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}) => {
  const types = useAppSelector(
    (state) => state.tradingAccounts.tradingAccountSubscriptionClassificationTypes
  )
  const data = types.length ? types.map((x) => ({ id: x.id, label: x.name, value: x.id })) : []

  return (
    <SelectFilter
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
      style={{ width: 200 }}
    />
  )
}

const SubscriptionDetailTypeFilter = ({
  filter,
  onFilterChange,
}: {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}) => {
  const types = useAppSelector(
    (state) => state.tradingAccounts.tradingAccountSubscriptionDetailTypes
  )
  const data = types.length ? types.map((x) => ({ id: x.id, label: x.name, value: x.id })) : []

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}

export const getSubscriptionFilterFields = (): FieldSettings[] => [
  {
    name: SubscriptionDetailDetailsFilterKey.name,
    label: 'Name',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.startsWithOperator,
        operator: GridFilterOperatorEnum.startsWithOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notStartsWithOperator,
        operator: GridFilterOperatorEnum.notStartsWithOperator,
      },
    ],
  },
  {
    name: SubscriptionDetailDetailsFilterKey.type,
    label: 'Classification Type',
    filter: SubscriptionClassificationTypeFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: SubscriptionDetailDetailsFilterKey.level,
    label: 'Detail Type',
    filter: SubscriptionDetailTypeFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
]
